import {Component, inject, Input, OnInit} from '@angular/core';
import {Match} from '../../../../../../model/events/Match';
import {SessionService} from '../../../../../../services/session.service';
import {RestErrorHelper} from '../../../../../../helper/rest-error-helper';
import {FrontendService} from '../../../../../../services/frontend.service';
import {TranslateModule} from '@ngx-translate/core';
import {MatchDatePipe} from '../../../../../../pipes/matchDate.pipe';
import {ParticipantPipe} from '../../../../../../pipes/participant.pipe';
import {MatchResultFullPipe} from '../../../../../../pipes/matchResultFullPipe';
import {SetlegmodePipe} from '../../../../../../pipes/setlegmode.pipe';
import {DurationPipe} from '../../../../../../pipes/duration.pipe';
import {DividerModule} from 'primeng/divider';
import {Button} from 'primeng/button';
import {CdkCopyToClipboard} from '@angular/cdk/clipboard';
import {TooltipModule} from 'primeng/tooltip';
import {
  FrontendPlayingvenueDataComponent
} from '../../../masterdata/frontend-playingvenue-details/frontend-playingvenue-data/frontend-playingvenue-data.component';

@Component({
  standalone: true,
  selector: 'app-event-match-details-info',
  templateUrl: './event-match-details-info.component.html',
  imports: [
    TranslateModule,
    MatchDatePipe,
    ParticipantPipe,
    MatchResultFullPipe,
    SetlegmodePipe,
    DurationPipe,
    DividerModule,
    Button,
    CdkCopyToClipboard,
    TooltipModule,
    FrontendPlayingvenueDataComponent
  ],
  styleUrls: ['./event-match-details-info.component.scss']
})
export class EventMatchDetailsInfoComponent implements OnInit
{
  private sessionService = inject(SessionService);
  public restErrorHelper = inject(RestErrorHelper);

  @Input() match: Match;
  isEDart: boolean;
  frontendLink: string;

  ngOnInit(): void
  {
    this.isEDart = this.sessionService.isEdart;

    console.log('window.location.href: ', window.location.origin);
    this.frontendLink = this.getFrontendLinkMatchplan();
    console.log('frontendLink: ', this.frontendLink);
  }

  private getFrontendLinkMatchplan(): string
  {
    console.log('Match: ', this.match);
    return window.location.origin + FrontendService.getMatchplanDirektLink(this.match.event, this.match.phase?.id,
      this.match.round?.id, this.match.id);
  }
}
